module.exports = __webpack_public_path__ + "img/6.91cc72d5.webp";